// app/components/approval/ApprovalList.tsx
import type { ApprovalCardItem } from "../../types/approval";
import ApprovalCard from "./ApprovalCard";

interface ApprovalListProps {
  items: ApprovalCardItem[];
  onReject?: (transId: number) => void;
  onApprove?: (transId: number) => void;
  onCardClick?: (item: ApprovalCardItem) => void;
}

const ApprovalList = ({
  items,
  onReject,
  onApprove,
  onCardClick,
}: ApprovalListProps) => {
  return (
    <div className="gx-approval-list">
      {items.map((item) => (
        <ApprovalCard
          key={item.transId}
          item={item}
          onReject={onReject}
          onApprove={onApprove}
          onClick={onCardClick}
        />
      ))}
    </div>
  );
};

export default ApprovalList;